// extracted by mini-css-extract-plugin
module.exports = {"calcTotal":"_1_XrcA13Et86","calcTotal__list":"_15pPyqCSCLri","calcTotal__item":"_1Bj-PlngBEBT","calcTotal__label":"jrCN7izZs1rg","calcTotal__value":"_5juHmiK1TGuK"};